import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalContext';
import { apiFetch } from '../../utils/api';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ContactDetails from './ContactDetails';
import EditContactForm from './EditContactForm';
import LoadingSpinner from '../LoadingSpinner';

function Contact() {
  const { id } = useParams();
  const { state, dispatch } = useGlobalState();
  const navigate = useNavigate();


  const contact = state.contacts.find((contact) => String(contact.id) === String(id));
  const [isEditing, setIsEditing] = useState(false);
  const [contactData, setContactData] = useState(contact);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    setContactData(contact || null);
  }, [contact]);

  const handleSave = (updatedContactData) => {
    setContactData(updatedContactData);
    setIsEditing(false);
  };

  const handleDelete = () => setShowDeleteModal(true);

  const confirmDelete = async () => {
    if (!contact?.id) return;
    setDeleting(true);
    try {
      await apiFetch('deleteContact', {
        method: 'POST',
        body: JSON.stringify({ contact_id: contact.id }),
      });
      dispatch({ type: 'DELETE_CONTACT', payload: contact.id });
      setShowDeleteModal(false);
      navigate('/contacts');
    } catch (err) {
      // Optionally, replace with Snackbar if preferred
      console.error('Failed to delete contact:', err);
    } finally {
      setDeleting(false);
    }
  };

  
  if (!contact) {
    return <p>Error: No contact found with ID {id}</p>;
  }
  if (!contact) return <LoadingSpinner message="Loading contact data…" />;



  return (
    <div>
      <button className="btn btn-light mt-2" onClick={() => navigate(-1)}>
        &larr; Back
      </button>

      {isEditing ? (
        <EditContactForm contactData={contactData} onSave={handleSave} />
      ) : (
        <>
          <div className="d-flex gap-2 mt-2">
            <button className="btn btn-secondary" onClick={() => setIsEditing(true)}>Edit</button>
            <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
          </div>
          <ContactDetails contactData={{ ...contactData }} setContactData={setContactData} />
        </>
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to delete <strong>{contact?.name}</strong>? This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete} disabled={deleting}>
            {deleting ? 'Deleting…' : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Contact;
